@if (booking) {
  <div class="modal-backdrop" (click)="closeModal()"></div>
  <div class="modal-container">
    <div class="modal-header">
      <h2 class="modal-title">Appointment Confirmed</h2>
      <span class="header-check-icon">&#10003;</span>
      <!-- Checkmark icon -->
    </div>
    <div class="modal-body">
      <div class="success-message-container">
        <div class="success-icon-wrapper">
          <svg class="success-icon" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M9,20.42L2.79,14.21L5.62,11.38L9,14.76L18.46,5.3L21.29,8.13L9,20.42Z"
            />
          </svg>
        </div>
        <p class="success-text">Success!</p>
      </div>

      <div class="booking-summary">
        <h3 class="summary-title">Booking Summary</h3>
        <div class="summary-item">
          <span class="label">Patient</span>
          <span class="value">{{ booking.patient.firstName }} {{ booking.patient.lastName }}</span>
        </div>
        <div class="summary-item">
          <span class="label">Date</span>
          <span class="value"
            >{{ booking.bookingSlot.slotDate | date: 'dd MMM yyyy' }}
            {{ booking.bookingSlot.slotTime | date: 'HH:mm' }}</span
          >
        </div>
        <div class="summary-item">
          <span class="label">Reason for Visit</span>
          <span class="value">{{ booking.reasonForVisit }}</span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="done-button" (click)="closeModal()">Done</button>
    </div>
  </div>
}
